/** A data como o auditor lê e como a API guarda — as duas pontas do mesmo dia. */

/** A API troca datas em ISO; a tela mostra em português. */
export const emBr = (iso: string) => iso.split('-').reverse().join('/')

/**
 * Data e hora de um instante que a API mandou em ISO com fuso.
 *
 * A hora aparece porque as duas datas da marca de laudo afetado podem cair no mesmo dia: baixar de
 * manhã e corrigir à tarde é o caso comum, e sem a hora a frase diria que as duas coisas
 * aconteceram ao mesmo tempo.
 */
export const momento = (iso: string) =>
  new Date(iso).toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
